import React from "react";
import { Modal, Box, Typography, Button, Alert, Divider } from "@mui/material";
import "./QuizDueDateModal.css";

const QuizDueDateModal = ({ open, onClose, quizTitle, dueDate }) => {
  const formatDate = (dateString) => {
    if (!dateString) return "No due date set";
    return new Date(dateString).toLocaleString();
  };

  return (
    <Modal open={open} onClose={onClose}>
      <Box className="quiz-due-date-modal">
        <Box className="quiz-due-date-modal-content">
          <Typography variant="h5" className="quiz-due-date-modal-title">
            Assessment Not Available
          </Typography>

          <Alert severity="error" className="quiz-due-date-modal-alert">
            This assessment has passed its due date. You cannot take it anymore.
          </Alert>

          <Box className="quiz-due-date-modal-details">
            <Typography variant="body1" gutterBottom>
              <strong>Assessment:</strong> {quizTitle}
            </Typography>
            <Typography variant="body1" gutterBottom>
              <strong>Due Date:</strong> {formatDate(dueDate)}
            </Typography>
          </Box>

          <Divider sx={{ my: 2 }} />

          <Box className="quiz-due-date-modal-actions">
            <Button
              variant="contained"
              onClick={onClose}
              className="quiz-due-date-modal-button"
            >
              Close
            </Button>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
};

export default QuizDueDateModal;

